import api from '@api/api';
import IHttpResponse from '@api/http-response';
import ILanguage from '@front/types/lang';

export const loadAll = (): Promise<IHttpResponse<ILanguage[]>> => {
  return api.get('/api/_supported-locales');
};